
import FinAgentQuestionLeftCard from "@/components/finagent/FinAgentQuestionLeftCard";

export default {
    name: "FinAgentFreePlanModal",

    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        FinAgentQuestionLeftCard
    },

    methods: {
        closeWindow() {
            this.$emit('input', false);
        },
    },
}
